import React from "react";
import { reportComponentError } from "../services/clientErrorLogger";
import logo from "../styles/img/logo.png";
import SupportContact from "./SupportContact/SupportContact";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportComponentError(error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <CrashFallback />;
    }
    return this.props.children;
  }
}

function resolveFallbackLanguage() {
  try {
    return localStorage.getItem("language") === "en" ? "en" : "sv";
  } catch {
    return "sv";
  }
}

const FALLBACK_TEXT = {
  sv: {
    heading: "Något gick fel",
    message: "Ett oväntat fel inträffade. Prova att ladda om sidan.",
    reload: "Ladda om sidan",
    help: "Behöver du hjälp? Kontakta supporten:",
  },
  en: {
    heading: "Something went wrong",
    message: "An unexpected error occurred. Please try reloading the page.",
    reload: "Reload the page",
    help: "Need help? Contact support:",
  },
};

function CrashFallback() {
  const text = FALLBACK_TEXT[resolveFallbackLanguage()];
  return (
    <div
      role="alert"
      className="d-flex align-items-center justify-content-center min-vh-100 p-4"
      style={{ backgroundColor: "#e4e5e6" }}
    >
      <div className="text-center w-100" style={{ maxWidth: "500px" }}>
        <img
          src={logo}
          alt="LearnWARE"
          className="d-block mx-auto mb-5"
          style={{ height: "40px", width: "auto" }}
        />
        <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
          <div
            className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle text-primary"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#e1f2fa",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h1
            className="mb-0"
            style={{ fontSize: "1.375rem", fontWeight: 600, color: "#29363d" }}
          >
            {text.heading}
          </h1>
        </div>
        <p className="mb-4" style={{ fontSize: "1rem", color: "#536c79" }}>
          {text.message}
        </p>
        <button
          type="button"
          className="btn btn-primary px-4 py-2"
          style={{ fontWeight: 500 }}
          onClick={() => window.location.reload()}
        >
          {text.reload}
        </button>
        <p
          className="mt-4 mb-2"
          style={{ fontSize: "0.85rem", color: "#536c79" }}
        >
          {text.help}
        </p>
        <SupportContact />
      </div>
    </div>
  );
}
